module.exports = __webpack_public_path__ + "static/media/14.ed9d17a8.png";